
import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import Index from "./pages/Index";
import ScreenDisplay from "./pages/ScreenDisplay";
import ScreenDisplayRight from "./pages/ScreenDisplayRight";
import Admin from "./pages/Admin";
import SpinToWin from "./pages/SpinToWin";
import PrizePage from "./pages/PrizePage";
import SubmitTip from "./pages/SubmitTip";
import ThankYou from "./pages/ThankYou";
import "./App.css";
import { suppressResizeObserverLoopError } from "./utils/resizeObserver";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  useEffect(() => {
    suppressResizeObserverLoopError();
    
    // Log route registration for debugging
    console.log('Available routes:', [
      '/',
      '/submit-tip',
      '/thank-you',
      '/screen_left',
      '/screen_right',
      '/admin',
      '/game/spin',
      '/game/prize/:tipId'
    ]);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          {/* Base routes */}
          <Route path="/" element={<Index />} />
          <Route path="/submit-tip" element={<SubmitTip />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/screen_left" element={<ScreenDisplay />} />
          <Route path="/screen_right" element={<ScreenDisplayRight />} />
          <Route path="/admin/*" element={<Admin />} />
          
          {/* Game routes with nested structure */}
          <Route path="/game">
            <Route index element={<Navigate to="/game/spin" replace />} />
            <Route path="spin" element={<SpinToWin />} />
            <Route path="spin/:tipId" element={<SpinToWin />} />
            <Route path="prize/:tipId" element={<PrizePage />} />
          </Route>
          
          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
